import React, {useEffect, useRef, useState} from 'react';

type RevealProps = {
    children: React.ReactNode;
    className?: string;
    delay?: number;
    as?: keyof JSX.IntrinsicElements;
};

// Fades/slides children in the first time they scroll into view.
function Reveal({children, className = '', delay = 0, as: Tag = 'div'}: RevealProps) {
    const ref = useRef<HTMLElement | null>(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el || typeof IntersectionObserver === 'undefined') {
            setVisible(true);
            return;
        }
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setVisible(true);
                observer.disconnect();
            }
        }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    const Component = Tag as any;
    return (
        <Component
            ref={ref}
            className={`reveal ${visible ? 'is-visible' : ''} ${className}`}
            style={{transitionDelay: `${delay}ms`}}
        >
            {children}
        </Component>
    );
}

export default Reveal;
